import * as Yup from 'yup';
import { endOfDay } from 'date-fns';
import { APPLICANT_TYPES } from '../../../constants/claim';
import { getLegalEntityValidator, getPhysicalEntityValidator } from '../claimApplicantDetailsValidation';

const personalInfoSchema = Yup.object().shape({
  firstName: Yup.string()
    .required('validationErrors.isRequired')
    .isCorrectLanguage(),
  lastName: Yup.string()
    .required('validationErrors.isRequired')
    .isCorrectLanguage(),
  passportNum: Yup.string()
    .min(3, 'validationErrors.wrongPassportNumber')
    .required('validationErrors.isRequired'),
  passportGivenDate: Yup.date()
    .nullable()
    .when(['isCitizen'], (isCitizen, schema) => {
      if (!isCitizen) {
        return schema
          .test(
            'passportGivenDate',
            'validationErrors.validityDate',
            (value) => new Date(value) <= endOfDay(new Date()),
          )
          .required('validationErrors.isRequired');
      }
      return schema;
    }),
  passportValidUntilDate: Yup.date()
    .nullable()
    .when(['isCitizen'], (isCitizen, schema) => {
      if (!isCitizen) {
        return schema.test(
          'validUntilDate',
          'validationErrors.validityDate',
          (value) => !value || endOfDay(new Date(value)) >= new Date(),
        );
      }
      return schema;
    }),
  passportFrom: Yup.string().when(['isCitizen'], (isCitizen, schema) => {
    if (!isCitizen) {
      return schema.required('validationErrors.isRequired');
    }
    return schema;
  }),
}).concat(Yup.object().shape(getPhysicalEntityValidator({
  when: 'applicantIs',
  genderKey: 'applicantGender',
  is: (applicantIs) => applicantIs === APPLICANT_TYPES[1].value,
}))).concat(Yup.object().shape(getLegalEntityValidator()));

export default personalInfoSchema;
